import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

/**
 * A message's Unix-seconds timestamp as both forms the feed needs: the exact
 * moment (tooltip, detail popup) and "3 minutes ago" (the card).
 *
 * Its own module rather than an export from TradeFeedCard: a file that exports
 * both a component and a helper loses React Fast Refresh, and the lint budget
 * is pinned, so that warning is a build failure here.
 */
export const formatMessageTime = (timestamp) => {
  if (!timestamp) return { absolute: "", relative: "" };

  const at = dayjs.unix(timestamp);

  return { absolute: at.format("DD MMM YYYY · HH:mm"), relative: at.fromNow() };
};

export default formatMessageTime;
